module.exports = __webpack_public_path__ + "static/media/22.c700c2dd.jpg";